var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import personalDataApi from "apis/eduidPersonalData";
import { useAppDispatch, useAppSelector } from "eduid-hooks";
import { useCallback, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import authnSlice from "slices/Authn";
export function UseSecurityKeyToggle() {
    const dispatch = useAppDispatch();
    const always_use_security_key = useAppSelector((state) => { var _a, _b, _c; return (_c = (_b = (_a = state.personal_data) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.preferences) === null || _c === void 0 ? void 0 : _c.always_use_security_key; });
    const [switchChecked, setSwitchChecked] = useState(always_use_security_key);
    const frontend_action = useAppSelector((state) => { var _a; return (_a = state.authn.response) === null || _a === void 0 ? void 0 : _a.frontend_action; });
    const [postSecurityKeyPreference, preference] = personalDataApi.usePostSecurityKeyPreferenceMutation();
    useEffect(() => {
        setSwitchChecked(always_use_security_key);
    }, [always_use_security_key]);
    useEffect(() => {
        if (!preference.isLoading) {
            setSwitchChecked(always_use_security_key);
        }
    }, [always_use_security_key, preference.isLoading]);
    const handleSwitchChange = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        dispatch(authnSlice.actions.setAuthnFrontendReset());
        setSwitchChecked(!switchChecked);
        if (switchChecked !== undefined) {
            postSecurityKeyPreference({ always_use_security_key: !switchChecked });
        }
    }), [dispatch, switchChecked, postSecurityKeyPreference]);
    useEffect(() => {
        // without checking for re_authenticate it will loop because makeGenericRequest() sets frontend_action
        if (frontend_action === "changeSecurityPreferencesAuthn") {
            handleSwitchChange();
        }
    }, [frontend_action, handleSwitchChange]);
    return (_jsx("form", { children: _jsx("fieldset", { className: "border-toggle-area", children: _jsxs("label", { className: "toggle", htmlFor: "security-key-mfa", children: [_jsxs("legend", { children: [_jsx(FormattedMessage, { id: "useSecurityKeyToggle.always", defaultMessage: `Always use a security key to log in`, description: "Security key toggle" }), _jsx("p", { className: "help-text", children: _jsx(FormattedMessage, { id: "useSecurityKeyToggle.help", description: "help text toggle MFA", defaultMessage: "If turned off you only need to use your security key for services that require extra login verification." }) })] }), _jsx("input", { onChange: handleSwitchChange, className: "toggle-checkbox", type: "checkbox", checked: switchChecked, id: "security-key-mfa" }), _jsx("div", { className: "toggle-switch" })] }) }) }));
}
